// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__1DBCw","pos":"Placeholder_pos__XGYo4","logo":"Placeholder_logo__X42JJ","desc":"Placeholder_desc__2SDCk"};